import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import cx from 'classnames';
import { DateInfo } from 'govbr.frontend.policy/components';

export const DefaultView = ({ item }) => {
  const { title, description, review_state } = item;
  const className = cx('text-up-02 text-weight-medium text-interactive', {
    [`review-state-${review_state}`]: review_state,
  });

  return (
    <div>
      <ConditionalLink
        item={item}
        className={className}
        aria-label={`Leia mais sobre ${title}`}
      >
        {title}
      </ConditionalLink>
      <div className="mb-2 text-up-01 text-gray-80">{description}</div>
      <DateInfo item={item} />
    </div>
  );
};
